import { useJqlContext } from '@atlassian/jira-business-entity-common/src/controllers/jql-context/index.tsx';
import { useListItemGroups as useListItemGroupsService } from '../../services/get-item-groups/index.tsx';
import { useGroupBy } from '../group-by/index.tsx';

export const useListItemGroups = () => {
	const [groupByFieldId] = useGroupBy();

	const jqlContext = useJqlContext();

	return useListItemGroupsService({
		input: {
			jqlContext,
			groupByFieldId,
		},
	});
};
